import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { useSeoContext } from '@sorare/core/src/contexts/seo';

import { Articles } from 'components/Articles';
import { Header } from 'components/Header';
import { useSection } from 'hooks/zendesk';
import { categoryPath, sectionPath } from 'lib/path';

const Section = () => {
  const { sectionId } = useParams();
  const { category, section } = useSection(sectionId);
  const { setPageMetadata } = useSeoContext();

  useEffect(() => {
    if (section) {
      setPageMetadata(section.name, { description: section.description });
    }
  }, [section, setPageMetadata]);

  if (!section || !category) {
    return <LoadingIndicator fullHeight />;
  }

  const sections = [
    {
      name: category.name,
      to: categoryPath(category),
    },
    {
      name: section.name,
      to: sectionPath(section),
    },
  ];

  return (
    <Vertical gap={3}>
      <Header sections={sections} />
      <Articles section={section} />
    </Vertical>
  );
};

export default Section;
